//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    size: {
      type: String,
      required: false,
      default: 'large'
    }
  },
  sizeClass(size) {
    const sizeClasses = {
      extralarge: 'text-6xl',
      large: 'text-2xl',
      medium: 'text-xl',
      'small-medium': 'text-lg',
      small: 'text-base'
    }
    return sizeClasses[size]
  }
}
